export default "__VITE_ASSET__Otp5OSAQ__"